import React from "react";
import { FinancialChartReference } from "models/AiResearch";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "./style.scss";

interface Props {
  reference: FinancialChartReference;
}

export const FinancialChart: React.FC<Props> = ({ reference }) => {
  const categories = reference.data.content.series[0].values.map(v => v.x);
  const seriesData = reference.data.content.series[0].values.map(v => v.y);

  const options: Highcharts.Options = {
    title: {
      text: "",
      useHTML: true,
      style: {
        whiteSpace: "normal"
      }
    },
    yAxis: {
      title: { text: "" },
      labels: {
        formatter() {
          return Highcharts.numberFormat(this.value as number, 0);
        }
      }
    },
    xAxis: {
      title: { text: reference.data.content.xLabel },
      categories,
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6"
    },
    series: [
      {
        type: reference.data.content.chartType,
        data: seriesData,
        name: reference.data.meta.name
      }
    ],
    exporting: {
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.citationNumber}>{reference.citationNumber}</span>
      <h2 className={styles.title}>{reference.data.meta.name}</h2>
      <p className={styles.description}>{reference.data.content.description}</p>
      <div className={styles.chartContainer}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          containerProps={{ className: styles.chartInner }}
        />
      </div>
    </div>
  );
};
